export const INTEGER = 'Integer';
//# sourceMappingURL=INTEGER.js.map